


















































import { Component, Mixins, Provide } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import PageMixin from "@/mixins/page"
import { Columns } from "./constant"
import { mapGetters } from "vuex"
import manageService from "@/services/manage.service"
@Component({
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["productSubTypeMap"])
    }
})
export default class ReleaseList extends Mixins(PageMixin) {
    @Provide()
    get useWrapperContext() {
        return this
    }
    readonly currentUser: any
    readonly productSubTypeMap: any

    activeTab: number = null
    visible = false
    loading = false
    dataSource: any[] = []
    productList: any = []

    model: any = {
        channel_name: "",
        version_name: "",
        product_id: undefined,
        sort: 0,
        start_date: null
    }
    pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: false,
        showSizeChanger: true
    }

    get columns() {
        const cols: any = []
        return [...cols, ...Columns]
    }

    async created() {
        await this.getUserProduct()
    }

    productFullNameGetter(product: any) {
        const { product_name, product_sub_type } = product
        return `${product_name || "-"}（${this.productSubTypeMap[product_sub_type] || "-"}）`
    }

    changeTab(val: any) {
        this.activeTab = val
        this.pagination.current = 1
        this.onSearch()
    }

    async getUserProduct() {
        try {
            const res = await manageService.getUserProduct({
                uid: this.currentUser.uid
            })
            const { list = [] } = res || {}
            this.productList = list || []
            this.activeTab = this.productList.length ? this.productList[0].product_id : null
        } catch (error) {
            this.$message.error(`${error}, 获取产品失败！`)
        }
    }

    async onSearch(
        keyword?: string,
        pagination?: any,
        sorts?: any[],
        filters?: any[]
    ): Promise<{ total: number; list: any[] }> {
        if (!this.activeTab) {
            return {
                list: [],
                total: 0
            }
        }
        Object.assign(this, { pagination })
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const query: any = {}
        filters.forEach(item => {
            if (item.dataIndex === "release_ratio") {
                query.release_ratio_start = item.keyword[0] || ""
                query.release_ratio_end = item.keyword[1] || ""
            } else if (item.dataIndex === "channel_name") {
                query.channel_id = item.keyword
            } else {
                query[item.dataIndex] = item.keyword
            }
        })
        const payload = {
            offset,
            limit,
            product_id: this.activeTab,
            sorts,
            ...query
        }
        this.loading = true
        try {
            const res = await manageService.getReleaseList(payload)
            const { list, total } = res
            this.dataSource = list || []
            return {
                list,
                total
            }
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
